import { Col, Flex, Tooltip, Typography } from "antd";
import { ColumnType } from "antd/es/table";

import {
  BID_STATUSES,
  DIRECTION_TEXT,
  BidGridDto,
  REVERSE_ORDER_MAP,
  CONTRACT_CURRENCY_ENUM,
  getEnumKeys,
  BID_REQUEST_STATUS_ENUM,
  FIAT_CURRENCY_ENUM,
  BALANCE_FILTERS_TITLE,
  NATIVE_TOKENS_ENUM,
} from "interfaces";
import { CURRENCY_TYPE, dateFormat, formatWithDecimals, getFilterIcon, getSortIcon, isStatusIncluded } from "utils";
import { DirectionIcon, DisplayAmount, getCryptoIconRound, Status } from "ui";
import { PendingActionsBidList } from "stores/PendingActionsBidList";
import FileIcon from "images/fileIcon.svg";

import { ReactComponent as InfoIcon } from "images/info.svg";

import styles from "./bids.module.css";

import { UserStore } from "stores/UserStore";
import { DIRECT_PAYMENT_CUSTOMER_LP } from "utils/envConstants";

export const getColumns = (
  bids: PendingActionsBidList,
  user: UserStore,
  fiatCurrencyList?: any
): Array<ColumnType<BidGridDto>> => {
  const { isProvider, isCustomer, isJuniorLP, isSeniorLP, isLPRiskManager } = user.roles;
  const isLpProvider = isJuniorLP || isSeniorLP || isLPRiskManager;
  const isDirectPaymentCustomerLp = isLpProvider && !DIRECT_PAYMENT_CUSTOMER_LP;
  return [
    // !isProvider && {
    //   dataIndex: "customerName",
    //   key: "companyName",
    //   title: "Компания",
    //   width: 255,
    //   sorter: { multiple: 1 },
    //   sortOrder: bids.sorters?.companyName ? REVERSE_ORDER_MAP[bids.sorters?.companyName] : undefined,
    //   sortIcon: getSortIcon,
    //   className: `text-clamp-ellipsis ${styles.companyName}`,
    //   render: (_: any, record: BidGridDto) => {
    //     return (
    //       <Tooltip trigger="hover" placement="topLeft" title={record.contract.companyName}>
    //         <span>{record.contract.companyName}</span>
    //       </Tooltip>
    //     );
    //   },
    // },
    // {
    //   dataIndex: "hid",
    //   key: "hid",
    //   title: "Номер заявки",
    //   width: 80,
    // },
    // !isProvider && {
    //   dataIndex: "unk",
    //   key: "unk",
    //   title: "Договор УНК",
    //   width: 150,
    //   render: (_: any, record: BidGridDto) => {
    //     return <span>{record.contract.unk}</span>;
    //   },
    // },
    {
      dataIndex: "hid",
      key: "hid",
      title: "Номер заявки",
      width: 100,
      render: (_: any, record: BidGridDto) => {
        return (
          <Flex gap="small" className="align-items-center">
            <div className="square icon-3xl bg-basic-200">
              <img src={FileIcon} alt="" />
            </div>
            <Typography.Text>№{record.hid}</Typography.Text>
          </Flex>
        );
      },
    },
    {
      dataIndex: "contractDirection",
      key: "contractDirection",
      title: "Тип",
      width: 60,
      // filterMultiple: false,
      // defaultFilteredValue: bids.queryParams["contractDirection"],
      // filtered: "contractDirection" in bids.queryParams,
      // filters: getEnumKeys(DIRECTION_TEXT).map((key) => ({
      //   text: DIRECTION_TEXT[key],
      //   value: key,
      // })),
      // filterIcon: (filtered: boolean) => getFilterIcon(filtered),
      render: (_: any, record: BidGridDto) => {
        return <DirectionIcon direction={record.contract.direction} />;
      },
    },
    !isDirectPaymentCustomerLp
      ? {
          dataIndex: "unk",
          key: "unk",
          title: "УНК договора",
          width: 180,
          render: (_: any, record: BidGridDto) => {
            return (
              <Flex vertical gap="small">
                <Typography.Text>{record.contract.unk}</Typography.Text>
                {!isProvider && !isCustomer && !isLPRiskManager && (
                  <Tooltip trigger="hover" placement="topLeft" title={record.contract.companyName}>
                    <Typography.Text type="secondary" className={`text-clamp-ellipsis ${styles.companyName}`}>
                      {record.contract.companyName}
                    </Typography.Text>
                  </Tooltip>
                )}
              </Flex>
            );
          },
        }
      : null,
    {
      dataIndex: "fiatAmount",
      key: "fiatCurrency",
      title: "Сумма в валюте договора",
      sorter: { multiple: 3 },
      sortOrder: bids?.sorters?.fiatAmount && REVERSE_ORDER_MAP[bids.sorters.fiatAmount],
      sortIcon: getSortIcon,
      // filterMultiple: false,
      // defaultFilteredValue: bids.queryParams["fiatCurrency"],
      // filtered: "fiatCurrency" in bids.queryParams,
      // filters: getEnumKeys(FIAT_CURRENCY_ENUM).map((key) => ({
      //   text: FIAT_CURRENCY_ENUM[key],
      //   value: key,
      // })),
      // filterIcon: (filtered: boolean) => getFilterIcon(filtered),
      width: 220,
      render: (_: any, record: BidGridDto) => {
        return (
          <DisplayAmount
            amount={record.fiatAmount}
            currency={record.fiatCurrency}
            showFlag
            squareBg
            withName
            currencyList={fiatCurrencyList?.currencyMap || {}}
          />
        );
      },
    },
    // !DIRECT_PAYMENT_CUSTOMER_LP
    //   ? {
    //       dataIndex: "amountRub",
    //       key: "amountRub",
    //       title: "Сумма в рублях",
    //       width: 250,
    //       align: "left",
    //       sortIcon: getSortIcon,
    //       sorter: { multiple: 2 },
    //       sortOrder: bids.sorters?.fiatCurrency ? REVERSE_ORDER_MAP[bids.sorters.fiatCurrency] : undefined,
    //       filterIcon: (filtered: boolean) => getFilterIcon(filtered),
    //       render: (_: any, record: BidGridDto) => {
    //         return record.amountRub ? (
    //           <DisplayAmount
    //             amount={record.amountRub}
    //             currency={CURRENCY_TYPE.RUB}
    //             showFlag
    //             squareBg
    //             withName
    //             currencyList={fiatCurrencyList?.currencyMap || {}}
    //           />
    //         ) : null;
    //       },
    //     }
    //   : null,

    {
      dataIndex: "amount",
      key: "currency",
      title: "Сумма в цифровой валюте",
      sorter: { multiple: 3 },
      sortOrder: bids?.sorters?.amount && REVERSE_ORDER_MAP[bids.sorters.amount],
      sortIcon: getSortIcon,
      // filterMultiple: false,
      // defaultFilteredValue: bids.queryParams["currency"],
      // filtered: "currency" in bids.queryParams,
      // filters: getEnumKeys(CONTRACT_CURRENCY_ENUM).map((key) => ({
      //   text: CONTRACT_CURRENCY_ENUM[key],
      //   value: key,
      // })),
      // filterIcon: (filtered: boolean) => getFilterIcon(filtered),
      align: "left",
      width: 200,
      render: (_: any, record: BidGridDto) => {
        return (
          <DisplayAmount amount={record.amount || 0} currency={record.currency || ""} showFlag squareBg withName />
        );
      },
    },

    {
      dataIndex: "balanceCurrency",
      key: "balanceCurrency",
      title: "Баланс на заявке",
      // sorter: { multiple: 3 },
      // sortOrder: bids?.sorters?.amount && REVERSE_ORDER_MAP[bids.sorters.amount],
      // sortIcon: getSortIcon,
      // filterMultiple: true,
      // defaultFilteredValue: bids.queryParams["balanceCurrency"],
      // filtered: "balanceCurrency" in bids.queryParams,
      // filterSearch: (value: string, record: { value: string }) => {
      //   return record.value.toLowerCase().includes(value.toLowerCase());
      // },
      // filters: getEnumKeys(BALANCE_FILTERS_TITLE)
      //   .filter((key) => (isCustomer ? !Object.keys(NATIVE_TOKENS_ENUM).includes(key) : key))
      //   .map((key) => ({
      //     text: (
      //       <>
      //         <div style={{ display: "inline-block" }}>
      //           <Flex align="center">
      //             <span style={{ width: "30px" }}>{key}</span>
      //             <Flex
      //               align="center"
      //               gap="small"
      //               justify="flex-end"
      //               style={{
      //                 width: "190px",
      //               }}
      //             >
      //               <span>{BALANCE_FILTERS_TITLE[key]} </span>
      //               <span style={{ marginTop: "5px" }}>{getCryptoIconRound(key, "md")}</span>
      //             </Flex>
      //           </Flex>
      //         </div>
      //       </>
      //     ),
      //     value: key,
      //   })),
      // filterIcon: (filtered: boolean) => getFilterIcon(filtered),
      width: 160,
      render: (_: any, record: BidGridDto) => {
        return (
          <Flex vertical gap={"small"}>
            {record.balance && "rubBalance" in record.balance && Number(record.balance.rubBalance) !== 0 && (
              <DisplayAmount amount={Number(record.balance.rubBalance) || 0} currency={"RUB"} showFlag />
            )}
            {record.nativeBalance !== 0 && !isCustomer && (
              <DisplayAmount amount={record.nativeBalance || 0} currency={record.network || ""} showFlag decimals={3} />
            )}
            {record.tokenBalance !== 0 && (
              <DisplayAmount amount={record.tokenBalance || 0} currency={record.currency ?? ""} showFlag />
            )}
          </Flex>
        );
      },
    },

    {
      dataIndex: "statusDate",
      key: "status",
      title: "Статус",
      sorter: { multiple: 2 },
      sortOrder: bids.sorters?.statusDate ? REVERSE_ORDER_MAP[bids.sorters?.statusDate] : undefined,
      sortIcon: getSortIcon,
      width: 230,
      align: "left",
      filterIcon: (filtered: boolean) => getFilterIcon(filtered),
      render: (_: any, record: BidGridDto) => {
        const isImp = record.contract.direction === "IMP";
        const isExp = record.contract.direction === "EXP";
        const isStatusDraft = isStatusIncluded(record.status, [BID_REQUEST_STATUS_ENUM.DRAFT]);
        const isStatusNew = isStatusIncluded(record.status, [BID_REQUEST_STATUS_ENUM.NEW]);

        const showNotificationCustomer = !record.destinationWalletVerified && isCustomer && isStatusDraft && isImp;
        const showNotificationProvider = !record.quoteDestinationWalletVerified && isProvider && isExp && isStatusNew;
        const showNotification = showNotificationCustomer || showNotificationProvider;

        return (
          <Flex justify="end">
            <Flex gap="xsmall" align="start">
              <Flex vertical gap="small" align="end">
                <Col>
                  <Status color={BID_STATUSES.colors[record.status]} children={BID_STATUSES.texts[record.status]} />
                </Col>
                <Flex gap="small" align="center">
                  {showNotification && (
                    <Tooltip title="Требуется подтверждение другим пользователем">
                      <InfoIcon style={{ width: 15, height: 15 }} className={styles.tooltipIcon} />
                    </Tooltip>
                  )}
                  <Typography.Text type="secondary">{dateFormat(record.statusDate, true)}</Typography.Text>
                </Flex>
              </Flex>
            </Flex>
          </Flex>
        );
      },
    },
  ].filter((c) => !!c) as Array<ColumnType<BidGridDto>>;
};
